import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HeaderProvider } from './context/HeaderContext';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { SearchProvider } from './context/SearchContext';
import AuthInitializer from './Components/Comman/AuthInitializer';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <BrowserRouter>
    <Provider store={store}>
      <AuthInitializer>
        <SearchProvider>
          <HeaderProvider>
            <App />
          </HeaderProvider>
        </SearchProvider>
      </AuthInitializer>
    </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
